import React from 'react';

export const Unmute: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='var(--primary-accent)'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    ></path>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M11.18 7.06l.3-.24a.323.323 0 01.448.044.306.306 0 01.072.197v9.878c0 .172-.142.31-.318.311a.323.323 0 01-.202-.07l-.3-.24v-.001l-.311-.248-.036-.028-2.721-2.176H5.635A.63.63 0 015 13.865v-3.73a.63.63 0 01.636-.622h2.475l2.722-2.176.037-.029.31-.247zm-2.34 3.365l1.993-1.594v6.338L8.84 13.575l-.32-.255H6.167v-2.64H8.52l.319-.255zm8.412 5.075a.58.58 0 01-.414-.992c.011-.011.997-1.038.997-2.508s-.986-2.497-.998-2.508a.581.581 0 01.006-.823.58.58 0 01.823 0l.009.01C17.802 8.815 19 10.094 19 12c0 1.906-1.199 3.185-1.326 3.32l-.01.01a.597.597 0 01-.413.17zm-2.748-1.336c.117.111.263.17.414.17a.597.597 0 00.417-.173c.088-.094.75-.805.75-2.16 0-1.372-.677-2.09-.753-2.16a.58.58 0 00-.816-.005.592.592 0 00-.018.822c.018.018.42.455.42 1.342 0 .836-.358 1.273-.408 1.335l-.006.007a.58.58 0 000 .822z'
      clipRule='evenodd'
    ></path>
  </svg>
);
